import { api } from '../lib/api-client';
import { readApiResult, type DataResult } from '../lib/data-result';
import { renderSkillGrid, type SkillListItem } from '../../../src/lib/ui/skill-card';
import { renderFlywheelHighlightsPanel, type FlywheelHighlights } from '../../../src/lib/ui/skill-flywheel';

type SkillSort = 'downloads' | 'recent' | 'name';

async function searchSkills(input: {
  search?: string;
  sort: SkillSort;
  limit?: number;
}): Promise<DataResult<{ items: readonly SkillListItem[]; total: number }>> {
  return readApiResult(
    () => api.skills.search({
      search: input.search || undefined,
      sort: input.sort,
      limit: input.limit || 60,
    }),
    'Failed to load skills.',
    {
      map: (data) => ({
        items: (data.items || []) as readonly SkillListItem[],
        total: data.total || 0,
      }),
    },
  );
}

async function loadFlywheelHighlights(): Promise<DataResult<FlywheelHighlights>> {
  return readApiResult(
    () => api.skills.getFlywheelHighlights(),
    'Failed to load workflow signals.',
  );
}

function renderGrid(items: readonly SkillListItem[]): string {
  return renderSkillGrid(items);
}

function renderHighlights(highlights: FlywheelHighlights | null): string {
  return renderFlywheelHighlightsPanel(highlights);
}

window.SkillsPageData = {
  searchSkills,
  loadFlywheelHighlights,
};

window.SkillsPageRenderers = {
  renderGrid,
  renderHighlights,
};
